import { ClientTypeE, UserRoleE } from "../../../models/enums";

/**
 * The client types that get the campaigns tour. Keep this aligned with the tours defined in
 * ./../tours/tours.js (keyed by the short user type from ./getUserType) — a client type listed here
 * without a matching tour would mount an empty tour, and one missing from here never sees its tour.
 */
const TOUR_CLIENT_TYPES = [
  ClientTypeE["Advertising Agency"],
  ClientTypeE.Broadcaster,
  ClientTypeE["Post/sound production"],
];

/**
 * Global admins are excluded regardless of their client type: they sit on a client of an eligible
 * type (e.g. JumboMedia Advertising = Advertising Agency), so the client-type check alone let the
 * welcome message / tour open for them. ./../components/TakeTourFloatingButton already hides the
 * "Show tutorial" button from these roles — this keeps the welcome message consistent with it.
 */
const TOUR_EXCLUDED_ROLES: string[] = [
  UserRoleE.GlobalAdmin,
  UserRoleE.GlobalAdminAndAdminContentManager,
];

export type TourEligibilityInput = {
  clientType?: ClientTypeE;
  role?: string;
};

/**
 * Whether this user gets the campaigns tour (welcome message included).
 *
 * This also decides who the notification popup has to wait for: for everyone else there is no
 * welcome message to close, so the tour gate is released immediately (see App.tsx).
 */
export const isTourEligibleUser = (user?: TourEligibilityInput) =>
  user?.clientType !== undefined &&
  TOUR_CLIENT_TYPES.includes(user.clientType) &&
  !TOUR_EXCLUDED_ROLES.includes(user.role ?? "");

export default isTourEligibleUser;
